<template>
  <WebsiteCmsShell title="Tambah Kategori Berita" subtitle="Buat kategori untuk mengelompokkan publikasi website" list-eyebrow="Tambah data" list-title="Form kategori" list-description="Lengkapi nama dan deskripsi kategori lalu simpan.">
    <template #list><Form :form="form" :route="'website-post-categories'" /></template>
  </WebsiteCmsShell>
</template>

<script>

import WebsiteCmsShell from "@/component/websites/WebsiteCmsShell.vue";
import Form from "@/component/websites/PostCategoryForm.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        description: ''
      },
    };
  },

  components: {
    WebsiteCmsShell,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Daftar Kategori Berita", route: "/website/post-category" },
      { title: "Tambah Kategori Berita" },
    ])
  },

}

</script>
